import { lazy } from 'react';

const Note = lazy(() => new Promise(resolve => resolve(import('./Note'))));
export { Note };
